var app = angular.module("leonardo");

var PropertyStates = function($stateProvider) {

  $stateProvider.state('property', {
    url: '/property',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'property.tasks',
    ncyBreadcrumb: {
      label : '{{ filterService.getLabelProperty() }}'
    }
  });

  $stateProvider.state('property-deleted', {
    url: "/property/deleted",
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/property/deleted-list.html',
        controller: 'DeletedProperties'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'PropertyDeletedFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Deleted Properties'
    }
  });

  $stateProvider.state('property.tasks', {
    url: "/tasks",
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/property/tasks.html',
        controller: 'PropertyTasks'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'PropertyTasksFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/tasks-list.html',
        controller: 'TaskActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Tasks'
    }
  });

  $stateProvider.state('property.tasks.approval', {
    url: "/approval/:pk?show_df&is_mrb&workflow",
    params: {
      pk: '',
      workflow: null,
      squash: false
    },
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/property/task-approval.html',
        controller: 'ApprovalTaskController'
      },
    },
    resolve: {
      approvalStepObj: ['TaskService', '$stateParams', '$q', function(TaskService, $stateParams, $q) {
        let defer = $q.defer();
        let pk = $stateParams.pk?.match(/\d+/)[0];
        TaskService.getApprovalReview(pk).then(function (approvalStep){
          defer.resolve(approvalStep);
        }, function () {
          defer.resolve(null);
        });
        return defer.promise;
      }],
    },
    ncyBreadcrumb: {
      label: 'Task approval'
    }
  });

  $stateProvider.state('property.tasks.incomplete', {
    url: "/incomplete?priority",
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/property/tasks-incomplete.html',
        controller: 'IncompleteTaskList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'PropertyTasksFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Tasks Overview'
    },
    onEnter: ['$stateParams', 'FilterService', function($stateParams, FilterService) {
      if ($stateParams.priority) {
        FilterService.setFilter('priority', $stateParams.priority);
      }
      else {
        FilterService.removeFilter('priority');
      }
    }],
    onExit: ['$stateParams', 'FilterService', '$location', function($stateParams, FilterService, $location) {
      if ($stateParams.priority) {
        FilterService.removeFilter('priority');
        $location.url($location.href);
      }
    }]
  });

  $stateProvider.state('property.tasks.snoozed', {
    url: "/snoozed",
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/property/tasks-snoozed.html',
        controller: 'PropertyTasks'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'PropertyTasksFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Tasks Snoozed'
    }
  });

  $stateProvider.state('property.tasks.cannot', {
    url: "/cannot-do",
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/property/tasks-cannot.html',
        controller: 'PropertyTasks'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'PropertyTasksFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'Tasks Cannot Do'
    }
  });


  $stateProvider.state('property.past-due', {
    url: "/past-due",
    title: 'Past due',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/property/past-due.html',
        controller: 'PropertyTasks'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/task/filters.html',
        controller: 'PropertyTasksFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/tasks-list.html',
        controller: 'TaskActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Past Due'
    }
  });
};

app.config(['$stateProvider', PropertyStates]);
